export type AppLanguage = 'cs' | 'en' | 'es' | 'sk' | 'de' | 'pl' | 'it' | 'fr';
